import React from "react"
import { PlusOutlined } from "@ant-design/icons"

import { hasAccess } from "@components/Authorization"

const LABEL_CREATE = "Add Liaison"


const getHeaderActions = (openCreateModal) => {
  const canCreateSponsor = hasAccess(["sponsors-write"])

  if (!canCreateSponsor) {
    return []
  }

  return [
    {
      icon: <PlusOutlined />,
      action: openCreateModal,
      title: LABEL_CREATE,
    },
  ]
}

export default getHeaderActions
